import React, { useState } from "react";
import {
  HAPTIC,
  haptic,
  hapticsEnabled,
  hapticsSupported,
  setHapticsEnabled,
} from "../../lib/haptics";

/**
 * Vibration on or off, remembered per device.
 *
 * Renders nothing where the browser cannot vibrate — on an iPhone a toggle
 * for a feature that does not exist is worse than no toggle. Turning it ON
 * fires a tick immediately, so the answer to "did that do anything?" is in
 * your hand rather than in the next round.
 */
export default function HapticsToggle({ className = "" }: { className?: string }) {
  const [enabled, setEnabled] = useState(() => hapticsEnabled());

  if (!hapticsSupported()) return null;

  const toggle = () => {
    const next = !enabled;
    setHapticsEnabled(next);
    setEnabled(next);
    if (next) haptic(HAPTIC.tick);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={enabled}
      className={`underline ${className}`}
    >
      {enabled ? "Vibration on" : "Vibration off"}
    </button>
  );
}
